<template>
  <span>
    <b-container fluid>
      <b-row class="rounded-0" bg-variant="white" align-v="center"
        ><b-img :src="require('@/assets/img/dadeschools4.png')" class="dshead d-none d-md-block" width="80px" alt="Dadeschools Logo" />
        <b-col align="left"
          ><div class="topbrand">
            <h5 class="text-dadeschools d-none d-xl-block p-0">
              <img _ngcontent-tcd-c142="" :src="require('@/assets/img/brand-name.svg')" width="250" alt="brand-name" class="title" style="margin-left: -1.5vw; margin-top: 0.5vw" />
            </h5></div
        ></b-col>
        <b-col align="right"><h5 class="d-none d-xl-block p-0">Secure Our Future</h5></b-col>
        <b-col align="right" class="d-none d-xl-block p-0 mx-0 my-0" sm="auto"> <img :src="require('@/assets/img/ChildrenMovingBanner_1.png')" width="200rem" alt="Secure Our Future Logo" /></b-col>
      </b-row>
    </b-container>
    <div id="nav-bar-fixed" class="nav-bar">
      <b-navbar toggleable="sm" type="dark" variant="dadeschools">
        <img :src="require('@/assets/img/dadeschools3.png')" class="d-block d-sm-none" height="60px" alt="Dadeschools Logo" />
        <b-navbar-brand href="/"><span class="sr-only">Home Page</span> </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav small class="p-2">
            <b-nav-item to="/" active-class="active"><b>Home</b></b-nav-item>
            <b-nav-item-dropdown left text="Navigate" no-caret>
              <b-dropdown-item to="/" @click="sectionRoute(1)">Introduction</b-dropdown-item>
              <b-dd-divider />
              <b-dropdown-item to="/" @click="sectionRoute(2)">Voting</b-dropdown-item>
              <b-dd-divider />
              <b-dropdown-item to="/" @click="sectionRoute(3)">Advisory Commitee</b-dropdown-item>
              <b-dd-divider />
              <b-dropdown-item to="/" @click="sectionRoute(4)">Why Now?</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item target="_blank" href="WHY Talking points flyer_10_17_22.pdf" no-caret>FAQ</b-nav-item>
            <b-nav-item to="/referendum"  no-caret>Referendum Cost Calculator</b-nav-item>
            <b-nav-item-dropdown left text="Town Hall Meetings"  no-caret>
              <b-dropdown-item to="/meeting">Town Hall Dates</b-dropdown-item>
              <b-dd-divider />
              <b-dropdown-item target="_blank" href="Referendum Town Hall - 2022Sept v4_EG - No notes.pdf" no-caret>Town Hall Presentation</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item target="_blank" href="/2022-11-08-ge-ev-schedule.pdf" no-caret>Early Voting Information</b-nav-item>
            <b-nav-item target="_blank" href= "https://www.miamidade.gov/elections/library/sample-ballots/2022-11-08-general-election-sample-ballot.pdf" no-caret>2022 Official Sample Ballot</b-nav-item>
            <b-nav-item to="/endorsements" no-caret>Endorsements</b-nav-item>
            <b-nav-item-dropdown left text="Town Hall Videos"  no-caret>
              <b-dropdown-item target="_blank" href="https://www.eduvision.tv/l?etLtytL" no-caret>MDSPD 210</b-dropdown-item>
            <b-dd-divider />
              <b-dropdown-item target="_blank" href="https://www.eduvision.tv/l?etLtyOe" no-caret>REFERENDUM VIDEO SOCI</b-dropdown-item>
            <b-dd-divider />
              <b-dropdown-item target="_blank" href="https://www.eduvision.tv/l?etLtyOA" no-caret>RRAS</b-dropdown-item>
            <b-dd-divider />
              <b-dropdown-item target="_blank" href="https://www.eduvision.tv/l?etLtyOL" no-caret>TESTIMONIALS</b-dropdown-item>
            <b-dd-divider />
              <b-dropdown-item target="_blank" href="https://www.eduvision.tv/l?etLtyge" no-caret>Unethia & Colleen. Day in a Life</b-dropdown-item>
          </b-nav-item-dropdown>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto align-items-center">
            <div id="google_translate_element2" style="display: none"></div>
            <div class="translation custom-padding">
              <select id="translate" aria-label="Pick Language" onchange="doGTranslate(this);" style="background-color: #205493; color: white; border: 1px white solid; border-radius: 20px; height: 32px; margin-top: 1px">
                <!-- <option selected disabled value="">Translate</option> -->
                <option value="en|en">English</option>
                <option value="en|ht">Haitian Creole</option>
                <option value="en|es">Spanish</option>
              </select>
            </div>
            <b-button variant="outline-light" class="mx-1 btn-sm background-color:transparent custom-padding" align-v="center" align-h="center" href="https://instagram.com/miamischools" target="_blank"> <font-awesome-icon :icon="['fab', 'instagram']" /><span class="sr-only">Miami-Dade County Public Schools' Instagram Page</span> </b-button>
            <b-button variant="outline-light" class="mx-1 btn-sm custom-padding" align-v="center" align-h="center" href="https://twitter.com/MDCPS" target="_blank"> <font-awesome-icon :icon="['fab', 'twitter']" /><span class="sr-only">Miami-Dade County Public Schools' Twitter Page</span> </b-button>
            <b-button variant="outline-light" class="mx-1 btn-sm custom-padding" align-v="center" align-h="center" href="https://www.facebook.com/miamischools" target="_blank"> <font-awesome-icon :icon="['fab', 'facebook-f']" /><span class="sr-only">Miami-Dade County Public Schools' Facebook Page</span> </b-button>
            <b-button variant="outline-light" class="mx-1 btn-sm custom-padding" align-v="center" align-h="center" href="https://www3.dadeschools.net/home" target="_blank"> <font-awesome-icon :icon="['fas', 'globe-americas']" /><span class="sr-only">Miami-Dade County Public Schools' Website</span> </b-button>
            <b-button variant="outline-light" class="mx-1 btn-sm custom-padding" align-v="center" align-h="center" href="https://www.youtube.com/user/miamischools" target="_blank"> <font-awesome-icon :icon="['fab', 'youtube']" /><span class="sr-only">Miami-Dade County Public Schools' Youtube Channel</span> </b-button>
            <!-- <b-button size="sm" class="bg-dark rounded-0 border-0 px-4 py-2 mr-3" type="submit">Strategic Dashboard</b-button> -->
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </span>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {}
  },
  methods:
  {
    sectionRoute(value) {
      if (value == 1) {
        window.location.href = "#introduction";
      }
      if (value == 2) {
        window.location.href = "#voting";
      }
      if (value == 3) {
        window.location.href = "#commitee";
      }
      if (value == 4) {
        window.location.href = "#whynow";
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.nav-bar
  position: sticky
  top: 0
  z-index: 100
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji
  font-size: 1.2rem
  font-weight: 400
  color: #212529
  margin-left: -1vw

.dropdown-item:hover
  background-color: red

.btn-sm
  border-radius: 100%
  width: 2rem
  height: 2rem
  align: center
  padding: 0
  line-height: 2rem
  vertical-align: center

  .b-col
    flex: 1

.dshead
  margin-left: 1.2vw
  margin-right: 1.2vw
  margin-top: .4vw
  margin-bottom: .6vw

.custom-padding
  margin: 0.5em 1em
</style>